import {
  FETCH_PROVIDER_CARE_CONVERSATIONS,
  CHAT_LOADER,
  FETCH_PATIENT_CARE_MESSAGES,
  ACTIVE_CHAT,
  SEND_CARE_MESSAGES,
  PROVIDER_SEARCH,
  START_PROVIDER_CHAT,
  SEND_PROVIDER_CONV_MESSAGES,
  FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS,
  CLEAR_SEARCH,
  PATIENT_CHAT_SEARCH,
  FETCH_PATIENT_CARE_CONVERSATION_OBJ,
  RESET_CHAT_WINDOW,
} from './constants';
import { CONVERSATION_MESSAGE_RECEIVED } from '../socket/constants';

const initialState = {
  careConversations: [],
  patientCareConversationObj: null,
  providerToProviderConversations: [],
  loaded: true,
  careMessages: [],
  activePatientId: null,
  activePatientDetails: null,
  activeCareConversationId: null,
  matchFound: [],
  isProviderChatActive: false,
  activeProviderId: null,
  activeProviderDetails: null,
  providerConvMessages: [],
  patientSearchResults: [],
};

const patientChatSearch = (state, action) => {
  const matchFound = [];
  const searchTerm = action.payload.toLowerCase();
  if (searchTerm.length === 0) {
    return { ...state, patientSearchResults: state.careConversations };
  }
  const regexp = new RegExp(searchTerm, 'g');
  const { careConversations } = state;
  careConversations
    .filter(obj => obj.patientDetails)
    .map(obj => {
      if (obj.patientDetails['firstName'].toLowerCase().match(regexp) || obj.patientDetails['lastName'].toLowerCase().match(regexp)) {
        matchFound.push(obj);
      }
    });
  return { ...state, patientSearchResults: matchFound };
};

const ChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_LOADER:
      return { ...state, loaded: false };
    case FETCH_PROVIDER_CARE_CONVERSATIONS:
      return {
        ...state,
        careConversations: action.payload.data,
        loaded: true,
        patientSearchResults: action.payload.data,
      };
    case FETCH_PATIENT_CARE_MESSAGES:
      return {
        ...state,
        careMessages: action.payload.data,
        loaded: true,
      };
    case ACTIVE_CHAT:
      return {
        ...state,
        activePatientId: action.payload.patientId,
        activePatientDetails: action.payload.patientDetails,
        activeCareConversationId: action.payload.careConversationId,
        isProviderChatActive: false,
      };
    case SEND_CARE_MESSAGES:
      return {
        ...state,
        careMessages: [...state.careMessages, action.payload],
      };
    case PROVIDER_SEARCH:
      return { ...state, matchFound: action.payload.data };
    case START_PROVIDER_CHAT:
      return {
        ...state,
        activeProviderId: action.payload.providerId,
        activeProviderDetails: action.payload.providerDetails,
        isProviderChatActive: true,
      };
    case SEND_PROVIDER_CONV_MESSAGES:
      return {
        ...state,
        providerConvMessages: [...state.providerConvMessages, action.payload],
      };
    case CONVERSATION_MESSAGE_RECEIVED:
      return {
        ...state,
        providerConvMessages: [...state.providerConvMessages, action.payload],
      };
    case FETCH_PROVIDER_TO_PROVIDER_CONVERSATIONS:
      return {
        ...state,
        providerToProviderConversations: action.payload.data,
        loaded: true,
      };
    case CLEAR_SEARCH:
      return { ...state, matchFound: [] };
    case PATIENT_CHAT_SEARCH:
      return patientChatSearch(state, action);
    case FETCH_PATIENT_CARE_CONVERSATION_OBJ:
      return {
        ...state,
        patientCareConversationObj: action.payload.data,
        loaded: true,
      };
    case RESET_CHAT_WINDOW:
      return {
        ...state,
        activePatientId: '',
        activePatientDetails: { firstName: '', lastName: '', imageUrl: null },
        activeCareConversationId: '',
        isProviderChatActive: false,
        careMessages: [],
      };
    default:
      return state;
  }
};

export default ChatReducer;
